export function createCustomShapeRenderer() {
  return function({ ctx, x, y, style, label }) {
    const r = 18;

    return {
      drawNode() {
        ctx.beginPath();

        const sides = 6;
        const a = (Math.PI * 2) / sides;

        ctx.moveTo(x, y + r);

        for (let i = 1; i < sides; i++) {
          ctx.lineTo(x + r * Math.sin(a * i), y + r * Math.cos(a * i));
        }

        ctx.closePath();
        ctx.save();
        ctx.fillStyle = style.color; // Use the specified fill color
        ctx.fill();
        ctx.restore();

        // Render custom text inside the shape
        ctx.save();
        ctx.font = '600 20px sans-serif';
        ctx.fillStyle = '#fff';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.fillText('P', x, y + 2); // Custom text
        ctx.restore();
      },
      drawExternalLabel() {
        // Draw the main label outside the shape
        ctx.save();
        ctx.font = '400 14px sans-serif';
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.fillText(label || '', x, y + r + 20); // Adjusted position below the shape
        ctx.restore();
      },
    };
  };
}
